<template>
    <div class="report-highlights mt-5">
        <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
            <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
        </div>
        <div class="row justify-content-center mb-5">
            <div class="col">
                <h1 class="section-highlights serif">{{highlightsData.name}}<button v-if="!editHighlights && getUserPermissions().edit_reports && !isGuest" class="btn btn-secondary" @click="editHighlightsData">Edit</button></h1>
                <span class="h-line"></span>
            </div>
        </div>
        <div v-if="editHighlights" class="row justify-content-center mt-5 mb-3" :class="{'not-showing': !showHighlights}">
        <transition name="fade-edit">
            <div v-if="!isGuest" v-show="showHighlights" class="col">
                <div class="row mb-5">
                    <div class="col highlights-wrap" data-highlight="high1">
                        <label class="font-weight-bold">Title 1: </label>
                        <input v-model="title_1" type="text" class="title_1 w-25" name="title_1" />
                        <h6 class="font-weight-bold my-2">Body 1: </h6>
                        <textarea class="froala-highlights highlight_1">{{body_1}}</textarea>
                    </div>
                </div>
                <div class="row mb-5">
                    <div class="col highlights-wrap" data-highlight="high2">
                        <label class="font-weight-bold">Title 2: </label>
                        <input v-model="title_2" type="text" class="title_2 w-25" name="title_2" />
                        <h6 class="font-weight-bold my-2">Body 2: </h6>
                        <textarea class="froala-highlights highlight_2">{{body_2}}</textarea>
                    </div>
                </div>
                <div class="row mb-5">
                    <div class="col highlights-wrap" data-highlight="high3">
                        <label class="font-weight-bold">Title 3: </label>
                        <input v-model="title_3" type="text" class="title_3 w-25" name="title_3" />
                        <h6 class="font-weight-bold my-2">Body 3: </h6>
                        <textarea class="froala-highlights highlight_3">{{body_3}}</textarea>
                    </div>
                </div>
                <div class="row mb-5">
                    <div class="col highlights-wrap" data-highlight="high4">
                        <label class="font-weight-bold">Title 4: </label>
                        <input v-model="title_4" type="text" class="title_4 w-25" name="title_4" />
                        <h6 class="font-weight-bold my-2">Body 4: </h6>
                        <textarea class="froala-highlights highlight_4">{{body_4}}</textarea>
                    </div>
                </div>
                <div class="row">
                    <template v-if="hasArchive">
                        <div class="col">
                            <button class="btn btn-secondary reverse float-right ml-3" @click="closeHighlights">Close</button>
                            <button class="btn btn-secondary float-right" @click="saveHighlights">Save</button>
                        </div>
                    </template>
                    <template v-else>
                        <div class="col-md-6">
                            <label class="font-weight-bold">Select a name for the archive: </label>
                            <input v-model="archive_name" type="text" class="w-50" name="archive_name" />
                        </div>
                        <div class="col-md-6">
                            <button class="btn btn-secondary reverse float-right ml-3" @click="closeHighlights">Close</button>
                            <button class="btn btn-secondary float-right" @click="saveHighlights">Save</button>
                        </div>
                    </template>
                </div>
            </div>
        </transition>
    </div>
        <transition name="fade-highlights">
            <div v-if="!editHighlights" class="row justify-content-center mt-5 mb-3">
                <template v-if="errors">
                    <div class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
                </template>
                <template v-else>
                    <div v-for="highlight in highlights" class="col highlights fr-text">
                        <h1 class="title serif" v-html="highlight.title">{{highlight.title}}</h1>
                        <div v-html="highlight.body">{{highlight.body}}</div>
                    </div>
                </template>
            </div>
        </transition>
        <hr>
    </div>
</template>

<script>
    export default {
        props: ['isBuilt', 'highlightsData', 'isGuest', 'hasSkb'],
        created() {
            if(this.isBuilt){
                this.isArchive = this.$store.state.isArchive;
                this.prefixed_id = this.isArchive ? this.highlightsData.archive_id : this.highlightsData.report_id;
                this.fetchServerData();
                event_bus.$on('archive_name', (archive_name) => {
                    this.archive_name = archive_name;
                    this.hasArchive = true;
                });
            }
        },
        data() {
            return {
                isArchive:null,
                highlights:[],
                editHighlights:false,
                showHighlights:false,
                title_1:'',
                title_2:'',
                title_3:'',
                title_4:'',
                body_1:'',
                body_2:'',
                body_3:'',
                body_4:'',
                errors:false,
                hasArchive:false,
                archive_name:null,
                reloading:false
            }
        },
        mounted(){
            event_bus.$on('reloading', () => {
                this.resetData();
                this.fetchServerData();
            });
        },
        methods: {
            resetData(){
                this.title_1 = '';
                this.title_2 = '';
                this.title_3 = '';
                this.title_4 = '';
                this.body_1 = '';
                this.body_2 = '';
                this.body_3 = '';
                this.body_4 = '';
                this.highlights = [];
            },
            fetchServerData(){
                if(this.reloading) return;
                this.reloading = true;
                let params = {
                    'isArchive':            this.isArchive,
                    'prefixed_id':          this.prefixed_id,
                    'client_id':            this.highlightsData.client_id,
                    'element_abbr':         this.highlightsData.element_abbreviation,
                    'dwm':                  this.$store.state.current_dwm,
                    'date_from':            this.$store.state.current_dates.date_from,
                    'date_to':              this.$store.state.current_dates.date_to,
                    'date_compare_from':    this.$store.state.current_dates.date_compare_from,
                    'date_compare_to':      this.$store.state.current_dates.date_compare_to,
                    'element_id':           this.highlightsData.element_id,
                    'report_element_id':    this.highlightsData.report_element_id,
                    'element_name':         this.highlightsData.name
                };
                params = encodeURIComponent(JSON.stringify(params));
                this.highlights = [];
                if(this.$store.state.isArchive){
                    axios.get(`/api/reporting/highlights/${this.$route.params.archive_id}/?params=${params}`).then((highlightsData) => {
                        if(highlightsData.data){
                            this.hasArchive = highlightsData.data.hasArchive;
                            this.errors = highlightsData.data.errors;
                            if(this.hasArchive){
                                this.archive_name = highlightsData.data.archive_name;
                            }
                            _.each(highlightsData.data, (highlight, index) => {
                                if(highlight.title && highlight.body){
                                    this.highlights.push(highlight);
                                }
                                this['title_'+index.substr(-1, 1)] = highlightsData.data[index]['title'];
                                this['body_'+index.substr(-1, 1)] = highlightsData.data[index]['body'];
                            });
                        }
                        this.reloading = false;
                    });
                }
                else{
                    axios.get(`/api/reporting/highlights/${this.$route.params.report_id}/?params=${params}`).then((highlightsData) => {
                        if(highlightsData.data){
                            this.hasArchive = highlightsData.data.hasArchive;
                            this.errors = highlightsData.data.errors;
                            if(this.hasArchive){
                                this.archive_name = highlightsData.data.archive_name;
                            }
                            _.each(highlightsData.data, (highlight, index) => {
                                if(highlight.title && highlight.body){
                                    this.highlights.push(highlight);
                                }
                                this['title_'+index.substr(-1, 1)] = highlightsData.data[index]['title'];
                                this['body_'+index.substr(-1, 1)] = highlightsData.data[index]['body'];
                            });
                        }
                        this.reloading = false;
                    });
                }
            },
            editHighlightsData(){
                const report_element_id = this.highlightsData.report_element_id;
                let params = {
                    'prefixed_id':          this.prefixed_id,
                    'client_id':            this.highlightsData.client_id,
                    'element_abbr':         this.highlightsData.element_abbreviation,
                    'element_id':           this.highlightsData.element_id,
                    'report_element_id':    this.highlightsData.report_element_id,
                    'element_name':         this.highlightsData.name,
                    'date_from':            this.$store.state.current_dates.date_from,
                    'date_to':              this.$store.state.current_dates.date_to,
                    'date_compare_from':    this.$store.state.current_dates.date_compare_from,
                    'date_compare_to':      this.$store.state.current_dates.date_compare_to,
                };
                event_bus.$emit('show_chatGPT', params);
                axios.get(`/api/reporting/hi_need_refresh/${report_element_id}`).then((response) => {
                    if(response.data.success == false){
                        const message = "Something changed in the builder, so you need a page refresh before editing this element."
                        this.notification(message, 'type-warning', 'INFORMATION', BootstrapDialog.SIZE_SMALL, 5000, function(){location.reload()});
                    }
                    else{
                        this.editHighlights = true;
                        this.openHighligthsFroalaEditor();
                    }
                });
            },
            openHighligthsFroalaEditor(){
                const vueInstance = this;
                setTimeout(function(){
                    $('#reporting_view').find('.froala-highlights').off('froalaEditor.initialized').froalaEditor({
                        key: 'AA12B9A4A4xC2D2F2B2A29A3C3A8B1D2sg1Ti1LXd2URVJh1DWXG==',
                        height: 200,
                        charCounterCount: false,
                        requestWithCORS: false,
                        htmlExecuteScripts: false,
                        htmlUntouched: true,
                        htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'b', 'base', 'blockquote', 'br', 'button', 'caption', 'cite', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'div', 'dl', 'dt', 'em', 'fieldset', 'figcaption', 'figure', 'footer', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'img', 'ins', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'nav', 'ol', 'optgroup', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 's', 'section', 'small', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'title', 'tr', 'u', 'ul'],
                        htmlRemoveTags: ['script', 'form', 'style', 'iframe', 'input', 'select', 'option', 'video', 'audio', 'canvas', 'code', 'object', 'keygen'],
                        toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'color', 'formatOL', 'formatUL', 'insertLink', 'insertTable', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', 'undo', 'redo'],
                        fontFamily: {
                            "Arial, Helvetica, sans-serif": 'Arial',
                            "Georgia, serif": 'Georgia',
                            "Impact, Charcoal, sans-serif": 'Impact',
                            "Tahoma, Geneva, sans-serif": 'Tahoma',
                            "Times New Roman, Times, serif": 'Times New Roman',
                            "Verdana, Geneva, sans-serif": 'Verdana',
                            "BentonSans Regular": 'BentonSans Regular',
                        }
                    });
                    vueInstance.showHighlights = true;
                }, 400);
            },
            saveHighlights(){
                let highlights = {};
                $('#reporting_view').find('div.highlights-wrap').each(function(idx, el) {
                    const $el = $(el);
                    const title = $el.find('input').val();
                    const body = $el.find('.froala-highlights').froalaEditor('html.get', true);

                    highlights[$el.attr('data-highlight')] = {'title':title, 'body':body};
                });

                const prefixed_id = this.isArchive ? this.$route.params.archive_id : this.$route.params.report_id;
                const report_element_id = this.highlightsData.report_element_id;

                axios.post(`/api/reporting/highlights`, {
                    isArchive:              this.isArchive,
                    prefixed_id:            prefixed_id,
                    report_element_id:      report_element_id,
                    client_id:              this.highlightsData.client_id,
                    date_from:              this.$store.state.current_dates.date_from,
                    date_to:                this.$store.state.current_dates.date_to,
                    date_compare_from:      this.$store.state.current_dates.date_compare_from,
                    date_compare_to:        this.$store.state.current_dates.date_compare_to,
                    highlights:             highlights,
                    hasArchive:             this.hasArchive,
                    archive_name:           this.archive_name,
                    hasSkb:                 this.hasSkb
                }).then((response) => {
                    if(response.data['need_refresh']){
                        const message = "This report have been modified in the builder and cannot be saved without losing this text. You will need to open a new version of this report and edit it again."
                        this.notification(message, 'type-warning', 'INFORMATION', BootstrapDialog.SIZE_SMALL, 20000);
                    }
                    else{
                        this.$notify({
                            type: 'success',
                            text: response.data['exists'] == true ? this.messages.HIGHLIGHTS_UPDATED : this.messages.HIGHLIGHTS_CREATED
                        });
                        const highlightsData = response.data['highlights'];
                        this.editHighlights = false;
                        this.showHighlights = false;
                        this.hasArchive = true;
                        this.highlights = [];
                        _.each(highlightsData, (highlight, index) => {
                            if(highlight.title && highlight.body){
                                this.highlights.push(highlight);
                            }
                            this['title_'+index.substr(-1, 1)] = highlightsData[index]['title'];
                            this['body_'+index.substr(-1, 1)] = highlightsData[index]['body'];
                        });
                        event_bus.$emit('archive_name', this.archive_name);
                    }
                });
            },
            closeHighlights(){
                const vueInstance = this;
                this.showHighlights = false;
                event_bus.$emit('hide_chatGPT', true);
                setTimeout(function(){
                    vueInstance.editHighlights = false;
                }, 1000);
            }
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    div.report-highlights{
        span.h-line{
            display:inline-block;
            border-top:0.3rem solid;
            border-bottom:0.3rem solid;
            border-radius:0.6rem;
            width:100%;
        }
        div.not-showing{
            display:none;
        }

        .fade-edit-enter-active{
            transition: opacity 2s;
        }
        .fade-edit-leave-active {
            transition: opacity 1s;
        }
        .fade-edit-enter, .fade-edit-leave-to {
            opacity: 0;
        }
        .fade-highlights-enter-active{
            transition: opacity 2s;
        }
        .fade-highlights-leave-active{
            transition: opacity .5s;
        }
        .fade-highlights-enter, .fade-highlights-leave-to /* .fade-leave-active до версии 2.1.8 */ {
            opacity: 0;
        }

        div.highlights{
            font-size:1.8rem;
            h1.title{
                font-size:4rem;
            }
        }
    }
</style>
